(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-slideshow"] && !Shopify.designMode) return;
  try {
    
(function(){
  let pageEngaged = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches;
  let engagementListenersAdded = false;
  const engagementCallbacks = new Set();

  function removePageEngagementListeners(){
    if (!engagementListenersAdded) return;
    window.removeEventListener('pointerdown', markPageEngaged);
    window.removeEventListener('touchstart', markPageEngaged);
    window.removeEventListener('keydown', markPageEngaged);
    engagementListenersAdded = false;
  }

  function addPageEngagementListeners(){
    if (pageEngaged || engagementListenersAdded) return;
    window.addEventListener('pointerdown', markPageEngaged, { once: true, passive: true });
    window.addEventListener('touchstart', markPageEngaged, { once: true, passive: true });
    window.addEventListener('keydown', markPageEngaged, { once: true });
    engagementListenersAdded = true;
  }

  function markPageEngaged(){
    if (pageEngaged) return;
    pageEngaged = true;
    removePageEngagementListeners();
    engagementCallbacks.forEach((callback) => callback());
    engagementCallbacks.clear();
  }

  function init(root){
    if (root.dataset.sliderInitialized === 'true') return;
    root.dataset.sliderInitialized = 'true';

    const track = root.querySelector('[data-track]');
    const dotsWrap = root.querySelector('[data-dots]');
    const prevBtn = root.querySelector('[data-prev]');
    const nextBtn = root.querySelector('[data-next]');
    const slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));

    const count = parseInt(root.getAttribute('data-count') || '0', 10);
    if (!track || count < 2) return;

    let index = 0;
    let timer = null;

    const autoplay = (root.getAttribute('data-autoplay') || '') === 'true';
    const interval = parseInt(root.getAttribute('data-interval') || '4000', 10);
    let pageLoaded = document.readyState === 'complete';
    if (!pageEngaged && navigator.userActivation && navigator.userActivation.hasBeenActive) {
      pageEngaged = true;
      removePageEngagementListeners();
    }
    let userEngaged = pageEngaged;
    let inView = !('IntersectionObserver' in window);
    let visibilityObserver = null;

    function hydrateSlide(i){
      const slide = slides[i];
      if (!slide) return;

      slide.querySelectorAll('source[data-srcset]').forEach((source) => {
        source.setAttribute('srcset', source.getAttribute('data-srcset'));
        source.removeAttribute('data-srcset');
      });

      const image = slide.querySelector('img[data-src]');
      if (image) {
        image.setAttribute('src', image.getAttribute('data-src'));
        image.removeAttribute('data-src');
        image.classList.remove('banner-slide--deferred');
      }
    }

    function primeNext(){
      if (count > 1) hydrateSlide((index + 1) % count);
    }

    function setDot(i){
      if (!dotsWrap) return;
      dotsWrap.querySelectorAll('[data-dot]').forEach((b) => {
        const bi = parseInt(b.getAttribute('data-dot'), 10);
        const active = bi === i;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function goTo(i, fromUser){
      index = (i + count) % count;
      hydrateSlide(index);
      track.style.transform = 'translateX(' + (-index * 100) + '%)';
      setDot(index);
      if (fromUser) restart();
    }

    function next(fromUser){ goTo(index + 1, fromUser); }
    function prev(fromUser){ goTo(index - 1, fromUser); }

    function stop(){
      if (timer) clearInterval(timer);
      timer = null;
    }

    function start(){
      if (!autoplay || !pageLoaded || !userEngaged || !inView) return;
      stop();
      primeNext();
      timer = setInterval(() => {
        next(false);
        primeNext();
      }, Math.max(1500, interval || 4000));
    }

    function restart(){
      if (autoplay) start();
    }

    if (nextBtn) nextBtn.addEventListener('click', () => next(true));
    if (prevBtn) prevBtn.addEventListener('click', () => prev(true));

    if (dotsWrap){
      dotsWrap.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-dot]');
        if (!btn) return;
        const i = parseInt(btn.getAttribute('data-dot'), 10);
        if (!isNaN(i)) goTo(i, true);
      });
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    /* ---------- Touch / mouse drag to swipe ---------- */
    const viewport = root.querySelector('.banner-slider__viewport') || track;
    let dragging = false, startX = 0, deltaX = 0, width = 0, moved = false;

    function onDown(e){
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; moved = false; deltaX = 0;
      startX = e.clientX;
      width = viewport.clientWidth || track.clientWidth || 1;
      track.style.transition = 'none';
      stop();
    }
    function onMove(e){
      if (!dragging) return;
      deltaX = e.clientX - startX;
      if (Math.abs(deltaX) > 5) moved = true;
      track.style.transform = 'translateX(calc(' + (-index * 100) + '% + ' + deltaX + 'px))';
    }
    function onUp(){
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      const threshold = Math.max(50, width * 0.15);
      if (deltaX <= -threshold) { next(true); }
      else if (deltaX >= threshold) { prev(true); }
      else { goTo(index, false); restart(); }
      deltaX = 0;
    }

    viewport.addEventListener('pointerdown', onDown);
    window.addEventListener('pointermove', onMove, { passive: true });
    window.addEventListener('pointerup', onUp);
    window.addEventListener('pointercancel', onUp);
    /* Suppress the click after a drag so slide links don't fire */
    viewport.addEventListener('click', (e) => {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    goTo(0, false);
    function onPageLoad(){
      pageLoaded = true;
      start();
    }

    function onPageEngagement(){
      userEngaged = true;
      start();
    }

    if (!userEngaged) {
      engagementCallbacks.add(onPageEngagement);
      addPageEngagementListeners();
    }

    if ('IntersectionObserver' in window) {
      visibilityObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target !== root) return;
          inView = entry.isIntersecting;
          if (inView) start();
          else stop();
        });
      }, { rootMargin: '200px 0px' });
      visibilityObserver.observe(root);
    }

    if (pageLoaded) start();
    else window.addEventListener('load', onPageLoad, { once: true });

    root._destroy = function(){
      stop();
      window.removeEventListener('load', onPageLoad);
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
      window.removeEventListener('pointercancel', onUp);
      engagementCallbacks.delete(onPageEngagement);
      if (engagementCallbacks.size === 0) removePageEngagementListeners();
      if (visibilityObserver) visibilityObserver.disconnect();
    };
  }

  function boot(scope){
    (scope || document).querySelectorAll('[data-banner-slider]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => boot(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('[data-banner-slider]').forEach((r) => {
      if (r._destroy) r._destroy();
      r.dataset.sliderInitialized = 'false';
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
